<template>
  <div class="tw-relative tw-inline-block" ref="menuRoot">
    <!-- Button -->
    <button
      @click="toggleMenu"
      :disabled="props.disabled || props.loading"
      :class="[
        'tw-h-[40px] tw-flex tw-items-center tw-border tw-rounded-[8px] tw-overflow-hidden tw-border-blue-dark-500',
        props.color === 'primary' && 'tw-bg-white tw-text-primary-500 tw-border-primary-500',
        (props.disabled && props.color === 'primary') && '!tw-text-primary-300 !tw-border-primary-300',
        props.color === 'blue-dark' && 'tw-bg-white tw-text-blue-dark-500 tw-border-blue-dark-500',
        (props.disabled && props.color === 'blue-dark') && '!tw-bg-gray-100 !tw-border-blue-dark-200',
        btn_clases
      ]"
    >
      <!-- Right side (text) -->
      <span class="tw-px-4 tw-py-2 tw-flex-1 tw-text-sm tw-font-medium">
        {{ props.label }}
      </span>

      <!-- Left side (icon) -->
      <span :class="[
        'tw-px-3 tw-py-2 tw-border-r tw-flex tw-items-center',
        props.color === 'primary' && 'tw-border-primary-500',
        props.color === 'blue-dark' && 'tw-border-blue-dark-500'
      ]">
        <loading-spinner v-if="props.loading" size="sm" :show="true" />
        <base-icon v-else icon="more" class="fs-21"></base-icon>
      </span>
    </button>
    <!-- Dropdown -->
    <transition
      enter-active-class="tw-transition tw-duration-300 tw-ease-out"
      enter-from-class="tw-opacity-0 tw-scale-95"
      enter-to-class="tw-opacity-100 tw-scale-100"
      leave-active-class="tw-transition tw-duration-200 tw-ease-in"
      leave-from-class="tw-opacity-100 tw-scale-100"
      leave-to-class="tw-opacity-0 tw-scale-95"
    >
      <div
        v-if="open"
        class="tw-absolute tw-inline-table tw-bottom-[calc(100%+5px)] tw-left-0 md:tw-bottom-0 md:tw-right-[calc(100%+5px)] tw-min-w-48 tw-bg-white tw-border tw-border-gray-500 tw-rounded-lg tw-shadow-lg tw-z-50 tw-overflow-hidden"
      >
        <ul class="options_list tw-text-sm tw-mb-0 tw-overflow-hidden">
          <slot name="options" />
        </ul>
      </div>
    </transition>

  </div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount, computed} from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import LoadingSpinner from "@/components/loading/LoadingSpinner.vue";

const open = ref(false);
const menuRoot = ref(null);

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'outline',
    validator(value) {
      return ['outline', 'fill'].includes(value);
    }
  },
  color: {
    type: String,
    default: 'primary',
    validator(value) {
      return ['primary', 'blue-dark'].includes(value);
    }
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
});
const toggleMenu = () => {
  open.value = !open.value;
};

// بستن منو وقتی بیرون کلیک می‌شود
const clickOutside = (e) => {
  if (menuRoot.value && !menuRoot.value.contains(e.target)) {
    open.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", clickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", clickOutside);
});

const btn_clases = computed(() => {
  let classes = ''
  if(props.variant === 'fill') {
    classes += `tw-bg-${props.color}-500 tw-text-white tw-border-${props.color}-500`;
  } else {
    classes += `tw-bg-white tw-text-${props.color}-500 tw-border-${props.color}-500`;
  }
  classes += props.class || ''
  return classes
})

</script>

<style>
.options_list  li [class^="icon-"]{
  @apply tw-align-middle
}
.options_list  li {
  @apply hover:tw-bg-gray-100 tw-whitespace-nowrap
}
.options_list * {
  @apply tw-text-blue-dark-400
}
</style>
